<template>
    <v-container fluid>
        <v-row d-block class="mb-3">
            <v-col cols="12" sm="12" md="6" lg="6" xl="6">
                <v-card>

                    <v-toolbar color="cyan" dark dense>
                        <v-toolbar-title>Instrucciones para Importar</v-toolbar-title>
                    </v-toolbar>

                    <v-list >
                        <template v-for="(item, index) in instrucciones">

                            <v-divider
                                v-if="item.divider"
                                :key="index"
                                :inset="item.inset">
                            </v-divider>

                            <v-list-item :key="item.instruccion">
                                <v-list-item-avatar size="28" color="info">
                                    <span class="white--text ">{{ index + 1 }}</span>
                                </v-list-item-avatar>

                                <v-list-item-content>
                                    <v-list-item-title
                                        v-html="item.instruccion"></v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                        </template>
                    </v-list>
                </v-card>
            </v-col>

            <v-col cols="12" sm="12" md="6" lg="6" xl="6">
                <v-card>
                    <v-card-text>

                        <v-form ref="form" v-model="valid" enctype="multipart/form-data">

                            <v-select
                                v-model="importarModel.unidad_operativa_id"
                                :label="importarForm.unidad_operativa_id.label"
                                :items="unidadesOperativas"
                                item-text="unidad_operativa"
                                item-value="unidad_operativa_id"
                                :rules="importarForm.unidad_operativa_id.rules"
                                prepend-icon="checklist"
                            />

                            <v-file-input
                                truncate-length="50"
                                :label="importarForm.archivo.label"
                                :placeholder="importarForm.archivo.placeholder"
                                v-model='importarModel.archivo'
                                :rules="importarForm.archivo.rules"
                                accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                                prepend-icon="description"
                            ></v-file-input>

                            <v-checkbox
                                v-model="importarModel.permitir_identidad_extranjera"
                                dense hide-details class="mt-0"
                                label="Este archivo trae pasaportes o documentos extranjeros"
                            />
                            <div class="text-caption grey--text text--darken-1 ml-8">
                                Sin marcar, solo se aceptan identidades hondureñas válidas de 13 dígitos. Así se detectan
                                las identidades mal digitadas antes de que entren a la base de datos.
                            </div>
                        </v-form>

                    </v-card-text>
                    <v-divider class="mt-1"></v-divider>
                    <v-card-actions class="justify-center py-3">

                        <v-btn small outlined @click="regresar">
                            <v-icon>arrow_back</v-icon>
                            Regresar
                        </v-btn>

                        <v-btn small outlined color="warning" @click="resetForm()">
                            <v-icon>restart_alt</v-icon>
                            Limpiar
                        </v-btn>

                        <v-btn small outlined color="primary" :loading="revisando" :disabled="loading" @click.stop="revisar()"
                               title="Comprueba identidades, nombres y números de registro sin guardar nada">
                            <v-icon>fact_check</v-icon>
                            Revisar archivo
                        </v-btn>

                        <v-btn small color="primary" :loading="loading" :disabled="revisando" @click.stop="importar()">
                            <v-icon>upload_file</v-icon>
                            Importar
                        </v-btn>

                    </v-card-actions>
                </v-card>
            </v-col>
        </v-row>

        <v-dialog
            v-model="showModalImportar"
            persistent
            fullscreen>
            <v-card>
                <v-card-title class="text-h5 pt-10">
                    Importando registros, no cierre la ventana. Esto puede durar varios minutos, espere a que termine el
                    proceso
                </v-card-title>

                <v-card-text>
                    <v-progress-linear
                        indeterminate
                        color="info"
                    ></v-progress-linear>
                </v-card-text>

            </v-card>

        </v-dialog>

        <informe-revision
            :visible="dialogoInforme"
            :informe="informe"
            :modo="modoInforme"
            @cerrar="cerrarInforme"
            @importar="importarTrasRevision"
        />
    </v-container>
</template>

<script>

import Auth from "@/services/auth";
import InformeRevision from "@/components/Importaciones/InformeRevision.vue";

export default {
    name: "AdministracionImportacionesConstanciasNuevo",
    components: {InformeRevision},
    data() {
        return {
            permisos: [],
            unidadesOperativas: [],
            valid: true,
            loading: false,
            importarModel: {
                unidad_operativa_id: null,
                archivo: null,
                permitir_identidad_extranjera: false,
            },
            showModalImportar: false,
            revisando: false,
            dialogoInforme: false,
            modoInforme: "revision",
            informe: null,
            importadas: 0,
            importarForm: {
                unidad_operativa_id: {
                    label: 'Unidad Operativa',
                    placeholder: 'Seleccione',
                    rules: [(v) => !!v || 'Campo requerido'],
                },
                archivo: {
                    label: 'Archivo Excel (.xlsx)',
                    placeholder: 'Elija el archivo formato Excel (.xlsx)',
                    rules: [(v) => !!v || 'Campo requerido'],
                },
            },
            instrucciones: [
                {
                    instruccion: " <a href='/documentos/Plantilla_Cargar_Cursos_Terminados.xlsx'>Descargar aquí la Plantilla de Importación</a>",
                    divider: false,
                    inset: false
                },
                {
                    instruccion: "Siga las instrucciones que vienen en el archivo en la hoja <b>Notas</b> y rellene con la data.",
                    divider: true,
                    inset: true
                },
                {
                    instruccion: "Seleccione la <b>Unidad Operativa</b> para vincular los registros importados.",
                    divider: true,
                    inset: true
                },
                {
                    instruccion: "Elija el archivo Excel (.xlsx).",
                    divider: true,
                    inset: true
                },
                {
                    instruccion: "Opcional, para auditoría: agregue al final las columnas <b>Código Currícula</b>, <b>Plataforma</b> y <b>Nombre exacto</b>.",
                    divider: true,
                    inset: true
                },
                {
                    instruccion: "Los participantes que ya existen se <b>actualizan</b> con los datos del Excel; una celda vacía no borra nada.",
                    divider: true,
                    inset: true
                },
                {
                    instruccion: "Pulse <b>REVISAR ARCHIVO</b>: comprueba identidades, nombres y registros <b>sin guardar nada</b> y le dice qué filas tienen problemas.",
                    divider: true,
                    inset: true
                },
                {
                    instruccion: "Pulse en el botón <b>IMPORTAR</b>.",
                    divider: true,
                    inset: true
                },
                {
                    instruccion: "Si aparece algún Aviso o Mensaje, siga las instrucciones e inicie nuevamente.",
                    divider: true,
                    inset: true
                }
            ]
            /////
        }
    },
    computed: {
        // DO some
    },
    methods: {
        regresar() {
            this.$router.go(-1)
        },
        datosFormulario() {
            if (!this.$refs.form.validate()) {
                this.$toast.warning("Complete la información requerida.");
                return null;
            }

            if (!this.importarModel.archivo) {
                this.$toast.warning("Seleccione el archivo formato Excel (.xlsx).");
                return null;
            }

            let formData = new FormData;
            formData.append("archivo", this.importarModel.archivo);
            formData.append("unidad_operativa_id", this.importarModel.unidad_operativa_id);
            formData.append("permitir_identidad_extranjera", this.importarModel.permitir_identidad_extranjera ? 1 : 0);
            return formData;
        },
        informeDe(datos) {
            return {
                resumen: datos.resumen || null,
                rechazadas: Array.isArray(datos.rechazadas) ? datos.rechazadas : [],
                avisos: Array.isArray(datos.avisos) ? datos.avisos : [],
            };
        },
        // Revisión previa: no guarda nada y conserva el archivo elegido.
        revisar() {
            const formData = this.datosFormulario();
            if (!formData) return;

            this.revisando = true;

            window.axios.post("/importaciones_constancias/validar", formData).then(response => {
                const datos = response.data.data;

                if (response.data.success && datos && datos.resumen) {
                    this.informe = this.informeDe(datos);
                    this.modoInforme = "revision";
                    this.dialogoInforme = true;
                } else {
                    this.$toast.error(response.data.message || "No se pudo revisar el archivo.", {timeout: 15000});
                }
            })
                .catch(error => this.errorDeEnvio(error, "No se pudo revisar el archivo."))
                .finally(() => {
                    this.revisando = false;
                });
        },
        importarTrasRevision() {
            this.dialogoInforme = false;
            this.importar();
        },
        importar() {
            const formData = this.datosFormulario();
            if (!formData) return;

            this.loading = true;
            this.showModalImportar = true;
            this.importadas = 0;

            window.axios.post("/importaciones_constancias/importar", formData).then(response => {
                const datos = response.data.data || {};
                const informe = this.informeDe(datos);

                if (response.data.success) {
                    this.importadas = datos.importadas || 0;
                    this.$toast.success(response.data.message, {timeout: 10000});

                    // Con rechazadas o avisos se muestra el detalle antes de volver a la lista.
                    if (informe.rechazadas.length || informe.avisos.length) {
                        this.informe = informe;
                        this.modoInforme = "importacion";
                        this.dialogoInforme = true;
                    } else {
                        this.regresar();
                    }
                } else {
                    if (informe.rechazadas.length) {
                        this.informe = informe;
                        this.modoInforme = "importacion";
                        this.dialogoInforme = true;
                    }

                    this.$toast.error(response.data.message, {
                        position: "top-center", timeout: 60000, hideProgressBar: true, closeButton: "button", icon: true
                    });
                }

                // El archivo ya se procesó: se limpia el formulario para el siguiente.
                this.resetForm();
            })
                .catch(error => this.errorDeEnvio(error, "No se pudo Importar."))
                .finally(() => {
                    this.loading = false;
                    this.showModalImportar = false;
                })
        },
        cerrarInforme() {
            this.dialogoInforme = false;
            if (this.modoInforme === "importacion" && this.importadas) this.regresar();
        },
        errorDeEnvio(error, mensaje) {
            console.log(error);
            const cuerpo = error.response && error.response.data;
            if (cuerpo && cuerpo.data && typeof cuerpo.data === "object" && !Array.isArray(cuerpo.data)) {
                mensaje = Object.values(cuerpo.data).flat().join(" ") || mensaje;
            } else if (cuerpo && cuerpo.message) {
                mensaje = cuerpo.message;
            }
            this.$toast.error(mensaje, {position: "top-center", timeout: 60000, closeButton: "button", icon: true});
        },
        getImportancionesCreate() {
            this.loading = true;

            // Get data;

            window.axios.get('/importaciones_constancias/create', {}).then(response => {
                if (response.data.success) {

                    this.unidadesOperativas = response.data.data.unidadesOperativas;

                } else if (response.data.success === false) {
                    this.$toast.error(response.data.message);
                }
            })
                .catch(error => {
                    console.log(error)
                    this.$toast.error("No se pudo obtener los datos para continuar.");
                })
                .finally(() => {
                    // Do some
                    this.loading = false;
                })
        },
        resetForm() {
            this.$refs.form.reset();
        }

    },
    created() {
        Auth.checkPermisos("/administracion/constancias").then((res) => {
            this.permisos = res;

            if(!this.permisos[8]) {
                this.regresar();
            }

            this.getImportancionesCreate();
        });
    }
}
</script>

<style>

</style>
